function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { Button } from '@goodrx/matisse-react';
import styled, { css } from 'styled-components';
import { getDataAttributes } from '@goodrx/x-core';
import { mediaMaxWidth } from '../../../../utils';
const StyledLink = styled.a`
  display: block;
  text-decoration: none;
  min-height: 48px;
  width: 100%;
  max-width: 256px;

  ${mediaMaxWidth({
  sm: css`
      max-width: 100%;
    `
})}
`;
const StyledButton = styled(Button)`
  min-height: 48px;
  height: 100%;
  width: 100%;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    height: 0;
  }
`;
export const Primary = /*#__PURE__*/forwardRef(({
  attributes,
  className,
  displayTitle,
  url
}, linkRef) => /*#__PURE__*/React.createElement(StyledLink, _extends({
  className: className,
  href: url || '#'
}, getDataAttributes(attributes), {
  ref: linkRef
}), /*#__PURE__*/React.createElement(StyledButton, null, displayTitle)));